module.exports = __webpack_public_path__ + "media/images/bordered-arrow-down-a74c8d6cd898a434d04b69e6ffab8b73.png";